import { render, staticRenderFns } from "./PhoneLogin.vue?vue&type=template&id=45c8b33e&scoped=true&"
import script from "./PhoneLogin.vue?vue&type=script&lang=js&"
export * from "./PhoneLogin.vue?vue&type=script&lang=js&"
import style0 from "./PhoneLogin.vue?vue&type=style&index=0&id=45c8b33e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c8b33e",
  null
  
)

export default component.exports